<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh"><a id="pxi">A<span class="small">CKNOWLEDGEMENTS</span></a></p><a id="pxi">
<p class="noindent"><b>A special thanks</b> goes to my husband, Jonathon Beamer, for giving me inspiration, vision and expertise throughout this project. I think I would have abandoned the work if you had not been that constant voice of encouragement.</p>
<p class="indent">Thank you, Jillian Freeland, Liesa Glander and Jennifer Villarreal for freely giving of yourselves to edit and provide feedback. Your support is greatly appreciated.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?0e912afc